export const SET_ACTIVE_TAB = 'boardView/SET_ACTIVE_TAB'
export const FETCH_CURRENT_BOARD_SUCCESS = 'boardView/FETCH_CURRENT_BOARD_SUCCESS'
export const FETCH_FEATURE_CONFIGURATION_SUCCESS = 'boardView/FETCH_FEATURE_CONFIGURATION_SUCCESS'
export const FETCH_NOTIFICATION_RECIPIENTS_SUCCESS = 'boardView/FETCH_NOTIFICATION_RECIPIENTS_SUCCESS'
export const FETCH_NOTIFICATION_CONFIGURATIONS_SUCCESS = 'boardView/FETCH_NOTIFICATION_CONFIGURATIONS_SUCCESS'
export const FETCHED_INTERACTION_FILTERS = 'boardView/FETCHED_INTERACTION_FILTERS'
export const CHANGED_ACTIVE_FILTER = 'boardView/CHANGED_ACTIVE_FILTER'
export const CHANGED_DATE_FILTER = 'boardView/CHANGED_DATE_FILTER'
export const CHANGED_ACTIVE_SORT = 'boardView/CHANGED_ACTIVE_SORT'
export const REMOVED_FILTERS = 'boardView/REMOVED_FILTERS'
export const CHANGED_SEARCH_QUERY = 'boardView/CHANGED_SEARCH_QUERY'
export const TOGGLED_USER_CHECK = 'boardView/TOGGLED_USER_CHECK'
export const CHECKED_ALL_USERS = 'boardView/CHECKED_ALL_USERS'
export const UNCHECKED_ALL_USERS = 'boardView/UNCHECKED_ALL_USERS'
export const SELECTED_USER = 'boardView/SELECTED_USER'
export const UNSELECTED_USER = 'boardView/UNSELECTED_USER'
export const FETCH_ACCESS_AUTHORIZATION_SUCCESS = 'boardView/FETCH_ACCESS_AUTHORIZATION_SUCCESS'
export const CHANGED_ACCESS_AUTHORIZATION_OPTION = 'boardView/CHANGED_ACCESS_AUTHORIZATION_OPTION'
export const CHANGED_ACCESS_AUTHORIZATION = 'boardView/CHANGED_ACCESS_AUTHORIZATION'
export const CHANGED_CONFIGURATION = 'boardView/CHANGED_CONFIGURATION'
export const CHANGED_ACCESS_AUTHORIZATION_PAGE_IMAGE = 'boardView/CHANGED_ACCESS_AUTHORIZATION_PAGE_IMAGE'
export const FETCH_CONFIGURATION_SUCCESS = 'boardView/FETCH_CONFIGURATION_SUCCESS'
export const TOGGLE_REQUIRE_SIGN_IN = 'boardView/TOGGLE_REQUIRE_SIGN_IN'
export const SAVE_CONFIGURATION_SUCCESS = 'boardView/SAVE_CONFIGURATION_SUCCESS'
export const SAVE_SETTINGS_SUCCESS = 'boardView/SAVE_SETTINGS_SUCCESS'
export const SAVE_SETTINGS_ERROR = 'boardView/SAVE_SETTINGS_ERROR'
export const DISCARD_SETTINGS_CHANGES = 'boardView/DISCARD_SETTINGS_CHANGES'
export const SET_IS_SAVED = 'boardView/SET_IS_SAVED'
export const CLEAR_CURRENT_BOARD = 'boardView/CLEAR_CURRENT_BOARD'
export const ARCHIVE_LEADS = 'boardView/ARCHIVE_LEADS'
export const FETCH_ACCOUNTS = 'boardView/FETCH_ACCOUNTS'
export const FETCH_ACCOUNTS_SUCCESS = 'boardView/FETCH_ACCOUNTS_SUCCESS'
export const FETCH_ACCOUNTS_ERROR = 'boardView/FETCH_ACCOUNTS_ERROR'
export const SET_ACCOUNTS_DATA_TO_FIRST_PAGE = 'boardView/SET_ACCOUNTS_DATA_TO_FIRST_PAGE'
export const FETCH_PRIVACY_MESSAGES_SUCCESS = 'boardView/FETCH_PRIVACY_MESSAGES_SUCCESS'
export const FETCH_PERSONALIZATION_ACTIVATION = 'boardView/FETCH_PERSONALIZATION_ACTIVATION'
export const UPDATE_PERSONALIZATION_ACTIVATION = 'boardView/UPDATE_PERSONALIZATION_ACTIVATION'
export const UPDATE_RECOMMENDATIONS_ACTIVATION = 'boardView/UPDATE_RECOMMENDATIONS_ACTIVATION'
export const FETCH_BOARD_SETTINGS_SUCCESS = 'boardView/FETCH_BOARD_SETTINGS_SUCCESS'
export const UPDATE_SEO = 'boardView/UPDATE_SEO'
export const UPDATE_ALLOW_EMBEDDING = 'boardView/UPDATE_ALLOW_EMBEDDING'
export const UPDATE_INCLUDE_ADDITIONAL_BOARD_SCRIPTS = 'boardView/UPDATE_INCLUDE_ADDITIONAL_BOARD_SCRIPTS'
export const UPDATE_SELECTED_CUSTOM_SCRIPTS = 'boardView/UPDATE_SELECTED_CUSTOM_SCRIPTS'
export const UPDATE_QUERY_PARAM_NAVIGATION = 'boardView/UPDATE_QUERY_PARAM_NAVIGATION'
export const ON_HOSTING_PAGE_URL_CHANGE = 'boardView/ON_HOSTING_PAGE_URL_CHANGE'
export const ON_HOSTING_PAGE_URL_CHANGE_ERROR = 'boardView/ON_HOSTING_PAGE_URL_CHANGE_ERROR'
export const UPDATE_LOCALIZATION = 'boardView/UPDATE_LOCALIZATION'
export const UPDATE_FAVICON = 'boardView/UPDATE_FAVICON'
export const UPDATE_INTEGRAIONS = 'boardView/UPDATE_INTEGRAIONS'
export const UPDATE_PRIVACY = 'boardView/UPDATE_PRIVACY'
export const UPDATE_NOTIFICATION_RECIPIENTS = 'boardView/UPDATE_NOTIFICATION_RECIPIENTS'
export const UPDATE_NOTIFICATION_CONFIGURATIONS = 'boardView/UPDATE_NOTIFICATION_CONFIGURATIONS'
export const FETCH_INVITER_PERSONALIZATION = 'boardView/FETCH_INVITER_PERSONALIZATION'
export const UPDATE_INVITER_PERSONALIZATION = 'boardView/UPDATE_INVITER_PERSONALIZATION'
export const UPDATE_INVITER = 'boardView/UPDATE_INVITER'
export const FETCH_CONTACT_CARD_PRESENTER = 'boardView/FETCH_CONTACT_CARD_PRESENTER'
export const UPDATE_CONTACT_CARD_PRESENTER = 'boardView/UPDATE_CONTACT_CARD_PRESENTER'
export const FETCH_BOARD_CUSTOM_FIELDS_SUCCESS = 'boardView/FETCH_BOARD_CUSTOM_FIELDS_SUCCESS'
export const UPDATE_BOARD_CUSTOM_FIELDS = 'boardView/UPDATE_BOARD_CUSTOM_FIELDS'
export const FETCH_BOARD_METADATA_SUCCESS = 'boardView/FETCH_BOARD_METADATA_SUCCESS'
export const UPDATE_BOARD_METADATA = 'boardView/UPDATE_BOARD_METADATA'
export const UPDATE_DEFAULT_ITEM_VIEWER = 'boardView/UPDATE_DEFAULT_ITEM_VIEWER'
